import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const editRefereeMutation = gql`
  mutation editReferee(
    $customerId: String!
    $subjectId: String!
    $email: String!
    $name: String!
    $phone: String!
  ) {
    editReferee(
      customerId: $customerId
      subjectId: $subjectId
      email: $email
      name: $name
      phone: $phone
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  email: string
  name: string
  phone: string
}

export type editEmployerRefereeMutationData = {
  editReferee: string
}

export const useEditRefereeMutation: WrappedMutation<
  editEmployerRefereeMutationData,
  MutationVars
> = () =>
  useMutation<editEmployerRefereeMutationData, MutationVars>(editRefereeMutation, {
    client: agentClient,
  })
